import React from "react";
import { TouchableOpacity, View } from "react-native";
import Svg, {
  Path,
  ClipPath,
  G,
  Defs,
  LinearGradient,
  Stop,
  Rect,
} from "react-native-svg";

import appStyles from "../../../appStyles";

export default function RoutinesIcon(props) {
  const w = props.width || 24;
  const h = props.height || 24;

  const gradientId = "paint0_linear_routine_icon" + Math.random();

  const TAG = props.onPress ? TouchableOpacity : View;

  return (
    <TAG style={[appStyles.iconContainer, props.style]} {...props}>
      <Svg
        width={w}
        height={h}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_routine_icon)">
          <Path
            d="M18.6464 16.3351C18.6464 16.4236 18.6464 16.4924 18.6464 16.5563C18.6464 16.9544 18.6464 17.3526 18.6464 17.7507C18.6547 17.9822 18.5892 18.2103 18.4593 18.4021C18.3294 18.5939 18.1419 18.7393 17.9238 18.8174C17.7362 18.8767 17.5405 18.9065 17.3438 18.9059C16.8965 18.9059 16.4442 18.9059 15.9969 18.9059H15.7807C15.7767 18.9763 15.7767 19.0469 15.7807 19.1173C15.7807 19.5793 15.7807 20.0365 15.7807 20.4985C15.7782 20.6966 15.7208 20.8902 15.6149 21.0577C15.5091 21.2251 15.3589 21.36 15.181 21.4472C14.9768 21.5497 14.7506 21.6003 14.5223 21.5947C14.4781 21.5971 14.4338 21.5971 14.3896 21.5947C10.8569 21.5947 7.32269 21.5947 3.78679 21.5947C3.58989 21.5983 3.39333 21.5768 3.20185 21.5308C3.00407 21.4811 2.82553 21.3738 2.68898 21.2223C2.55242 21.0709 2.46402 20.8822 2.43503 20.6804C2.4114 20.5407 2.39989 20.3993 2.40062 20.2577V8.97655C2.39822 8.81137 2.41471 8.64644 2.44977 8.485C2.5073 8.24851 2.64292 8.03833 2.83471 7.88847C3.02649 7.73861 3.26322 7.65783 3.50661 7.6592H5.27128C5.27128 7.57563 5.27128 7.51173 5.27128 7.44783V6.12064C5.26508 5.97093 5.28991 5.82156 5.34422 5.68191C5.39852 5.54226 5.48114 5.41536 5.58685 5.30918C5.69257 5.203 5.81912 5.11983 5.95853 5.06492C6.09794 5.01 6.2472 4.98452 6.39693 4.99007H8.21076C8.21454 4.91803 8.21454 4.84583 8.21076 4.77379C8.21076 4.37563 8.21076 3.97747 8.21076 3.58423C8.20881 3.40972 8.24677 3.23706 8.32173 3.07946C8.3967 2.92185 8.5067 2.78346 8.64332 2.67486C8.81978 2.51458 9.04465 2.41772 9.28234 2.39959H20.3963C20.6766 2.38272 20.9537 2.46638 21.1779 2.63554C21.2971 2.73152 21.3957 2.85071 21.4675 2.98591C21.5393 3.1211 21.5829 3.26947 21.5957 3.42202C21.5982 3.46787 21.5982 3.51381 21.5957 3.55966V15.1455C21.6037 15.3128 21.5739 15.4796 21.5083 15.6337C21.4428 15.7878 21.3433 15.925 21.2172 16.0352C21.0608 16.1872 20.8549 16.278 20.6372 16.2908L18.8873 16.3252L18.6464 16.3351ZM10.4817 14.0887H19.3641V4.6509C19.1724 4.59683 10.6095 4.60666 10.4817 4.6509V14.0887ZM4.63226 9.90559V19.368H13.5146V18.9256H13.2836H6.52965C6.28813 18.9275 6.0505 18.8647 5.84148 18.7437C5.67348 18.6415 5.53544 18.4968 5.44135 18.3242C5.34727 18.1516 5.30046 17.9571 5.30569 17.7606V10.1612C5.30569 10.0776 5.30569 9.99407 5.30569 9.90559H4.63226ZM16.4 16.3203H9.77389C9.60185 16.3203 9.42981 16.3203 9.28234 16.2958C9.09998 16.2809 8.92481 16.218 8.7746 16.1135C8.62438 16.0091 8.50448 15.8667 8.42704 15.701C8.33312 15.4998 8.28927 15.2789 8.29924 15.057C8.29924 12.5305 8.29924 10.0023 8.29924 7.47241C8.29924 7.38884 8.29924 7.31019 8.29924 7.22171H7.52259V16.6792H16.4V16.3203Z"
            fill={`url(#${gradientId})`}
          />
        </G>
        <Defs>
          <LinearGradient
            id={gradientId}
            x1="2.40039"
            y1="6.56111"
            x2="11.6429"
            y2="25.4445"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <ClipPath id="clip0_routine_icon">
            <Rect
              width="19.1951"
              height="19.2"
              fill="white"
              transform="translate(2.40039 2.40039)"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </TAG>
  );
}
